export const testAttributes = {
    LC_ARTICLE_GRID_CONTAINER: 'lc-article-grid-container',
    LC_ARTICLE_GRID_TITLE: 'lc-article-grid-title',
};

export const defaultTitle = 'Recommended For You';
